import { render, staticRenderFns } from "./TextareaControl.vue?vue&type=template&id=1c29e842&"
import script from "./TextareaControl.vue?vue&type=script&lang=js&"
export * from "./TextareaControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports